
function PageTitlesFunc({title='' ,description='' ,canonical=''} = {}) {
    document.title = title;
    let nofollowB = document.querySelector('meta[name=robots]');
    let meta = document.querySelector('meta[name=description]');
    let link = document.querySelector('link[rel=canonical]');
    if(nofollowB){
        nofollowB.remove();
    }
    if(meta){
        meta.remove();
    }
    if(link){
        link.remove();
    }
    let desc = document.createElement("meta");
    let cano = document.createElement("link");
    desc.name = 'description';
    desc.content = description;
    cano.rel = 'canonical';
    cano.href = canonical;
    document.getElementsByTagName('head')[0].appendChild(desc);
    document.getElementsByTagName('head')[0].appendChild(cano);
}
export default PageTitlesFunc;
